// extracted by mini-css-extract-plugin
module.exports = {"root":"CardPermits_root__yj1Jr"};